import Vue from 'vue'
export const eventBus = new Vue()


//////////////////
// WEBPACK FOOTER
// ./eventBus.js
// module id = null
// module chunks = 